interface SceneTagProps {
  x: number;
  y: number;
  width: number;
  label: string;
}

// Green pill label floating in an industry hero scene (SVG group).
const SceneTag = ({ x, y, width, label }: SceneTagProps) => (
  <g transform={`translate(${x} ${y})`}>
    <rect x="4" y="8" width={width} height="32" rx="16" className="fill-ink/10" />
    <rect x="0" y="0" width={width} height="32" rx="16" className="fill-tone-mint-ink" />
    <text
      x={width / 2}
      y="21"
      textAnchor="middle"
      className="fill-white text-[13px] font-bold"
    >
      {label}
    </text>
  </g>
);

export default SceneTag;
